import React, { useState, useRef, useEffect } from "react";
import Octicon from "react-octicon";
import {
  fetcher,
  doFetch,
} from "@action.sustainability/storybook-dashboard/utils/fetching";

import FileSaver from "file-saver";

import useCCPApi, { CCP_API_URL } from "../fetching";

function FileDropZone({ companyId, draftId, type }) {
  const [showDropArea, setShowDropArea] = useState(false);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef();

  const postFileUrl = `${CCP_API_URL}/${companyId}/product/draft/${draftId}/document`;

  const { data: draftData } = useCCPApi(
    `${CCP_API_URL}/${companyId}/product/${type}/${draftId}`,
  );

  const documents = draftData?.get("documents");

  const onFileDrop = (e) => {
    e.preventDefault();
    const newFiles = e.dataTransfer.files;
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);

    Array.from(newFiles).forEach(async (file) => {
      const documentData = JSON.stringify({
        description: `${file.name}`,
      });
      const formData = new FormData();
      formData.append("file", file);
      formData.append("document_data", documentData);

      try {
        const { payload } = await fetcher(postFileUrl, "POST", formData);

        console.log(payload.toJS(), "Successful Upload!");
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    });
  };

  const onFileSelect = (e) => {
    const newFiles = e.target.files;
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    Array.from(newFiles).forEach(async (file) => {
      const documentData = JSON.stringify({
        description: `${file.name}`,
      });
      const formData = new FormData();
      formData.append("file", file);
      formData.append("document_data", documentData);

      try {
        const { payload } = await fetcher(postFileUrl, "POST", formData);

        console.log(payload.toJS(), "Successful Upload!");
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    });
  };

  const deleteFile = (fileName, documentId) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    const deleteFilesUrl = `${CCP_API_URL}/${companyId}/product/draft/${draftId}/document/${documentId}`;
  };

  const onDragOver = (e) => e.preventDefault();

  const openFileDialog = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <div>
        <h4 className="my-4 font-weight-bold">Evidence documentation</h4>
        <ul className="list-group mt-3">
          {documents
            ?.map((doc, index) => {
              const filename = doc.get("details").get("description");
              return (
                <li
                  key={index}
                  className="list-group-item btn-link d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer", textDecoration: "none" }}
                >
                  <a
                    key={index}
                    download
                    className="btn btn-sm btn-link"
                    onClick={async () => {
                      const fileUrl = `${CCP_API_URL}/${companyId}/shared/file/${doc?.get("file_id")}`;
                      const fileData = await doFetch(fileUrl);
                      FileSaver.saveAs(await fileData.blob(), filename);
                    }}
                  >
                    {filename}
                  </a>
                  {type === "draft" && (
                    <button
                      className="btn btn-sm btn-outline-danger mr-2"
                      onClick={async () => {
                        await fetcher(
                          `${CCP_API_URL}/${companyId}/product/draft/${draftId}/document/${doc?.get(
                            "document_id",
                          )}`,
                          "DELETE",
                          {},
                        );
                      }}
                    >
                      Delete
                    </button>
                  )}
                </li>
              );
            })
            ?.toJS()}
          {/* Below are the files from state  */}
          {files.map((file, index) => (
            <li
              key={index}
              className="list-group-item btn-link d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer", textDecoration: "none" }}
            >
              {file.name}
              <button
                className="btn btn-sm btn-outline-danger mr-2"
                onClick={() => deleteFile(file.name)}
              >
                Delete
              </button>
            </li>
          ))}
        </ul>
      </div>
      {type === "draft" && (
        <>
          {!showDropArea ? (
            <button
              className="btn btn-primary mt-3"
              onClick={() => setShowDropArea(true)}
            >
              Upload supporting information <Octicon className="ml-2" name="cloud-upload" />
            </button>
          ) : (
            <div className="container mt-4">
              <div
                onClick={openFileDialog}
                onDragOver={onDragOver}
                onDrop={onFileDrop}
                className=" d-flex justify-content-center align-items-center"
                style={{
                  height: "200px",
                  cursor: "pointer",
                  border: "3px dashed grey",
                  borderRadius: "5px",
                }}
              >
                <p className="text-bold text-center">
                  Drag files here or click to select files
                </p>
              </div>
              <input
                ref={fileInputRef}
                type="file"
                className="d-none"
                multiple
                onChange={onFileSelect}
              />

              <button
                className="float-right btn btn-outline-primary mt-3"
                onClick={() => setShowDropArea(false)}
              >
                Done
              </button>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default FileDropZone;
